/**
 * Partner welcome emails point at the marketing root with `?uuid=<token>`, so the
 * root and /equity-protect landing pages have to hand those visitors to the
 * activation page with the query string intact. Any other route is left alone.
 */
export const PARTNER_ACTIVATE_PATH = "/partner-activate";

const REDIRECTABLE_PATHS = ["/", "/equity-protect"];

export const partnerActivateToken = (search) =>
  new URLSearchParams(search || "").get("uuid") || "";

export const partnerActivateRedirectPath = (pathname, search) => {
  if (!partnerActivateToken(search)) {
    return null;
  }

  const path = String(pathname || "")
    .toLowerCase()
    .replace(/(.)\/$/, "$1");
  if (!REDIRECTABLE_PATHS.includes(path)) {
    return null;
  }

  return `${PARTNER_ACTIVATE_PATH}${search || ""}`;
};
